import * as React from "react"
import { LogoSkeleton, LogoProps } from "./skeleton"

export function WordpressLogo(props: LogoProps) {
  return (
    <LogoSkeleton {...props} logoName="WordpressLogo">
      <path
        d="M1.42139 10.0001C1.42139 13.3957 3.39473 16.3301 6.25624 17.7207L2.1641 6.50879C1.68811 7.57569 1.42139 8.75637 1.42139 10.0001Z"
        fill="#464342"
      />
      <path
        d="M15.7914 9.56728C15.7914 8.50708 15.4106 7.77285 15.0839 7.20136C14.6491 6.49472 14.2415 5.8963 14.2415 5.18966C14.2415 4.40107 14.8396 3.667 15.682 3.667C15.7201 3.667 15.7561 3.67174 15.7932 3.67386C14.2669 2.27559 12.2335 1.42188 10.0002 1.42188C7.00317 1.42188 4.36644 2.95955 2.83252 5.28858C3.03379 5.29462 3.22347 5.29886 3.38458 5.29886C4.28188 5.29886 5.67084 5.18998 5.67084 5.18998C6.13329 5.16272 6.18781 5.84194 5.72585 5.89663C5.72585 5.89663 5.26113 5.95131 4.744 5.97841L7.86798 15.2705L9.74534 9.64009L8.40878 5.97808C7.94683 5.95098 7.50919 5.8963 7.50919 5.8963C7.04691 5.8692 7.10111 5.1624 7.56339 5.18966C7.56339 5.18966 8.9801 5.29854 9.82304 5.29854C10.7202 5.29854 12.1093 5.18966 12.1093 5.18966C12.5721 5.1624 12.6264 5.84162 12.1643 5.8963C12.1643 5.8963 11.6986 5.95098 11.1825 5.97808L14.2826 15.1999L15.1383 12.3405C15.5092 11.1539 15.7914 10.3017 15.7914 9.56728Z"
        fill="#464342"
      />
      <path
        d="M10.1505 10.75L7.57666 18.2292C8.34517 18.4552 9.15791 18.5787 10 18.5787C10.999 18.5787 11.9571 18.406 12.8488 18.0925C12.8258 18.0557 12.8049 18.0167 12.7878 17.9743L10.1505 10.75Z"
        fill="#464342"
      />
      <path
        d="M17.5274 5.88379C17.5643 6.15704 17.5852 6.45038 17.5852 6.76591C17.5852 7.63644 17.4226 8.61503 16.9329 9.83864L14.3125 17.4149C16.8629 15.9276 18.5783 13.1645 18.5783 9.99975C18.5785 8.50828 18.1975 7.10576 17.5274 5.88379Z"
        fill="#464342"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 9.99976C0 4.48585 4.48618 0 10.0001 0C15.5138 0 20.0005 4.48585 20.0007 9.99976C20.0007 15.5143 15.5138 20 10.0001 20C4.48618 20 0 15.5143 0 9.99976ZM0.458512 9.99978C0.458512 15.2612 4.73902 19.5417 10.0001 19.5417C15.261 19.5417 19.5411 15.2612 19.5411 9.99978C19.5411 4.73873 15.261 0.45855 10.0001 0.45855C4.73885 0.45855 0.458512 4.73873 0.458512 9.99978Z"
        fill="#464342"
      />
    </LogoSkeleton>
  )
}
